import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { LicenseBadge } from '@/components/fintech/LicenseBadge';

export function PublicFooter({ company }) {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t bg-[hsl(var(--brand-navy-2))] text-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img src="/logo-light.png" alt="Concorde Financial Limited" className="h-12 w-auto mb-3" />
            <div className="font-serif text-xl mb-3">{company?.name || 'Concorde Financial Limited'}</div>
            <p className="text-sm text-white/70 leading-6">
              {company?.address}
            </p>
            <div className="mt-4"><LicenseBadge /></div>
          </div>
          <div data-testid="footer-license-block">
            <div className="text-xs uppercase tracking-wider text-[hsl(var(--brand-gold))] mb-3">{t('footer.license_title')}</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li>{t('about.director')}: {company?.director || 'Aleksejs Kozirevs'}</li>
              <li>Regulator: {company?.regulator || 'Anjouan Offshore Finance Authority'}</li>
              <li>License: {company?.license || 'L16195/CFL'}</li>
              <li>Jurisdiction: {company?.jurisdiction || 'Union of Comoros'}</li>
              <li>Valid until: {company?.license_valid_until || '2026-11-03'}</li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-[hsl(var(--brand-gold))] mb-3">{t('footer.legal_title')}</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li><a href="/documents" data-testid="footer-documents-link" className="hover:text-white transition-colors">{t('nav.documents')}</a></li>
              <li><a href="/contact" className="hover:text-white transition-colors">{t('nav.contact')}</a></li>
              <li><a data-testid="footer-contact-email" href={`mailto:${company?.email || 'info@concorde24.pro'}`} className="hover:text-white transition-colors">{company?.email || 'info@concorde24.pro'}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10">
          <p className="text-xs leading-5 text-white/60">{t('footer.disclaimer')}</p>
          <p className="mt-3 text-xs text-white/50">{t('footer.copyright', { year })}</p>
        </div>
      </div>
    </footer>
  );
}
